import { applyFiltersToQuery } from "../applyOperatorToSupabase";
import { getTableForColumn } from "../../../components/MainContent/hooks/useTableColumnsConfig";
import { RELATED_TABLES } from "../index";
import { filterInfluencersByRelatedTables } from "../filterByRelatedTables";

export const categorizeFilters = (filters) => {
  return filters.reduce(
    (acc, filter) => {
      const tableName = getTableForColumn({ columnKey: filter.column });
      if (tableName && RELATED_TABLES.includes(tableName)) {
        acc.relatedTableFilters.push(filter);
      } else {
        acc.regularFilters.push(filter);
      }
      return acc;
    },
    { relatedTableFilters: [], regularFilters: [] }
  );
};

export const applyRelatedTableFilters = async (supabase, relatedTableFilters) => {
  if (relatedTableFilters.length === 0) return null;
  return await filterInfluencersByRelatedTables(supabase, relatedTableFilters);
};

export const applyRegularFilters = (query, regularFilters, filtersLogic) => {
  if (regularFilters.length === 0) return query;
  return applyFiltersToQuery(query, regularFilters, filtersLogic);
};
